<script lang="ts">
  import { Card, CardHeader, Col, Container, Image, Row } from "sveltestrap";
  import BookmarkUserCards from "./BookmarkUserCards.svelte";
  import data from "../../../../Data/Users/Users.json";
  import UserCardsProfile from "./UserCardsProfile.svelte";
  let imgPath: string = "/assets/images";
</script>

<BookmarkUserCards />
<Container fluid class="user-card">
  <Row>
    {#each data.usercarddata as userData}
      <Col md="6" lg="6" xl="4" class="box-col-6">
        <Card class="custom-card">
          <CardHeader>
            <Image fluid src="{imgPath}/user-card/{userData.bgimg}" alt="" />
          </CardHeader>
          <div class="card-profile">
            <Image
              class="rounded-circle"
              src="{imgPath}/avtar/{userData.img}"
            />
          </div>
          <ul class="card-social">
            {#each userData.socialdata as userItem}
              <li>
                <a href={userItem.link}><i class={userItem.icon} /></a>
              </li>
            {/each}
          </ul>
          <UserCardsProfile userData={userData}/>
        </Card>
      </Col>
    {/each}
  </Row>
</Container>
